import React, {forwardRef} from 'react';
import {
  AddCircleOutline as AddBox,
  ArrowUpward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteForever as DeleteOutline,
  Build as Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from '@material-ui/icons';

// These must be plain icons, not buttons. material-table already wraps them
// in its own IconButton (actions, pagination, edit rows) or TableSortLabel
// (sortable headers). Wrapping them in another IconButton nests a <button>
// inside a <button> with a focusable descendant (WCAG 4.1.2). The outer
// buttons get their accessible names from material-table's tooltips and
// aria-labels.
const icon = (Component) =>
  forwardRef((props, ref) => <Component {...props} ref={ref} />);

export const tableIcons = {
  Add: icon(AddBox),
  Check: icon(Check),
  Clear: icon(Clear),
  Delete: icon(DeleteOutline),
  DetailPanel: icon(ChevronRight),
  Edit: icon(Edit),
  Export: icon(SaveAlt),
  Filter: icon(FilterList),
  FirstPage: icon(FirstPage),
  LastPage: icon(LastPage),
  NextPage: icon(ChevronRight),
  PreviousPage: icon(ChevronLeft),
  ResetSearch: icon(Clear),
  Search: icon(Search),
  SortArrow: icon(ArrowUpward),
  ThirdStateCheck: icon(Remove),
  ViewColumn: icon(ViewColumn),
};
